import { useCart } from "../../context/CartContext";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
// import "../../styles/Cart.css";
import "./Cart.css";
//import NextCart from "../components/Cart/NextCart";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import LoginModal from "../../components/Auth/LoginModal";
export default function Cart() {
  const {
    cart,
    removeFromCart,
    increaseQty,
    decreaseQty,
    isValidating,
    totalPrice,
    finalPrice,
    discountAmount,
    moveToNextCart,
    validateCart,
    invalidCartItems,
    getCartItemKey,
  } = useCart();



  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  const [isCheckingCart, setIsCheckingCart] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [checkoutAfterLogin, setCheckoutAfterLogin] = useState(false);

  const handleCheckout = async () => {
    // Don't do anything while AuthContext is still loading
    if (authLoading) return;

    // User is not logged in
    if (!user) {
      setCheckoutAfterLogin(true);
      setLoginOpen(true);
      return;
    }

    try {
      setIsCheckingCart(true);

      const isValid = await validateCart();

      if (!isValid) {
        return;
      }

      navigate("/checkout");
    } finally {
      setIsCheckingCart(false);
    }
  };

  useEffect(() => {
    if (!authLoading && user && checkoutAfterLogin) {
      const continueCheckout = async () => {
        setCheckoutAfterLogin(false);
        setLoginOpen(false);

        try {
          setIsCheckingCart(true);

          const isValid = await validateCart();

          if (!isValid) {
            return;
          }

          navigate("/checkout");
        } finally {
          setIsCheckingCart(false);
        }
      };

      continueCheckout();
    }
  }, [
    user,
    authLoading,
    checkoutAfterLogin,
    validateCart,
    navigate,
  ]);


  if (cart.length === 0) {
    return (
      <main className="cart-page">
        <div className="cart-container">
          <div className="empty-cart">
            <div className="empty-cart-icon">🛒</div>
            <h2>سبد خرید شما خالی می باشد.</h2>

            {/* <p>
             محصولی هنوز به سبد خرید اضافه نشده.
            </p> */}

            <button
              className="continue-shopping-btn"
              onClick={() => navigate("/products")}
            >
              ادامه خرید
            </button>
          </div>
        </div>
      </main>
    );
  }

  


  return (
    <>
      <main className="cart-page">
        <div className="cart-container">
          {/* HEADER */}
          {/* <div className="cart-header">
          <div>
            <h1>Shopping Cart</h1>

            <p>
              {cart.length}{" "}
              {cart.length === 1
                ? "product"
                : "products"}{" "}
              in your cart
            </p>
          </div>

          <button
            className="continue-shopping-link"
            onClick={() => navigate("/products")}
          >
            ← Continue Shopping
          </button>

         
        </div> */}

          <div className="cart-layout">
            {/* CART ITEMS */}
            <section className="cart-items-section">
              {cart.map((item) => {
                const variation = item.selectedVariation;

                const variationId = variation?.variationId ?? null;

                const giftId = item.selectedGift?.id ?? null;

                // const itemKey = [
                //   item.id,
                //   variationId ?? "no-variation",
                //   giftId ?? "no-gift",
                // ].join("-");

                const itemKey = getCartItemKey(item.id, variationId, giftId);

                const validationError = invalidCartItems[itemKey];

                const loading = isValidating(item.id, variationId, giftId);

                const price =
                  variation?.finalPrice ??
                  variation?.salePrice ??
                  variation?.price ??
                  item.finalPrice ??
                  item.salePrice ??
                  item.price ??
                  0;

                const originalPrice = variation?.price ?? item.price ?? price;

                const stock = variation?.quantity ?? item.quantity ?? 999999;



                const getItemImage = (item) => {

                  const images = item?.images;

                  return (
                    (Array.isArray(images) ? images[0]?.url || images[0]?.src || images[0]?.path : null) ||
                    null
                  );
                };

                const image = getItemImage(item);
             

                return (
                  // <article
                  //   key={itemKey}
                  //   className={`cart-product ${loading
                  //     ? "cart-product--loading"
                  //     : ""
                  //     }`}
                  // >
                  <article
                    key={itemKey}
                    className={`cart-product ${validationError ? "cart-product-invalid" : ""
                      }`}
                  >
                    {/* PRODUCT IMAGE */}
                    <div className="cart-product-image">
                      {/* <img
                      src={
                        item.image ||
                        item.thumbnail ||
                        "/images/product-placeholder.png"
                      }
                      alt={item.name}
                    /> */}

                      <Link
                        to={`/product/${item?.slug || item?.id}`}
                        className="mini-cart-item__image"
                        aria-label={`مشاهده ${item.name}`}
                      >
                        {image ? (
                          <img src={image} alt={item.name} />
                        ) : (
                          <ShoppingCart size={24} />
                        )}
                      </Link>
                    </div>

                    {/* PRODUCT INFORMATION */}
                    <div className="cart-product-info">
                      <h2>{item.name}</h2>

                      {item.selectedVariation.attributes && (
                        <div className="cart-attribute">
                          <span>
                            {item.selectedVariation.attributes.attribute}:
                          </span>

                          <strong>
                            {item.selectedVariation.attributes.value}
                          </strong>
                        </div>
                      )}

                      {variation?.name && (
                        <div className="cart-variation">{variation.name}</div>
                      )}

                      {variation?.color && (
                        <div className="cart-variation">
                          <span
                            className="variation-color"
                            style={{
                              backgroundColor: variation.color,
                            }}
                          />

                          {variation.color}
                        </div>
                      )}

                      {item.selectedGift && (
                        <div className="cart-gift">
                          <span>🎁</span>

                          <span>هدیه: {item.selectedGift.name}</span>
                        </div>
                      )}

                      {/* <div className="cart-stock">
                      {stock > 0 ? (
                        <>
                          <span className="stock-dot" />
                          In stock
                        </>
                      ) : (
                        <>
                          <span className="out-stock-dot" />
                          Out of stock
                        </>
                      )}
                    </div> */}

                      {validationError && (
                        <div className="cart-stock-error">
                          <span className="cart-stock-error-icon">×</span>

                          <div>
                            <strong>موجودی محصول تغییر کرده است</strong>
                            <p>{validationError}</p>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* PRICE */}
                    <div className="cart-product-price">
                      {originalPrice > price && (
                        <span className="cart-original-price">
                          {originalPrice.toLocaleString("en-US")}
                        </span>
                      )}

                      <strong>{price.toLocaleString("en-US")}</strong>

                      {/* <span className="currency">
                      $
                    </span> */}
                    </div>

                    {/* QUANTITY */}
                    <div className="cart-quantity-wrapper">
                      {/* <span className="quantity-label">
                      Quantity
                    </span> */}

                      <div
                        className={`cart-quantity ${loading ? "cart-quantity--loading" : ""
                          }`}
                      >
                        <button
                          type="button"
                          className="quantity-btn quantity-btn--plus"
                          disabled={loading}
                          onClick={() =>
                            increaseQty(item.id, variationId, giftId)
                          }
                        >
                          +
                        </button>

                        <span className="quantity-value">
                          {loading ? (
                            <span className="quantity-spinner" />
                          ) : (
                            item.qty
                          )}
                        </span>

                        <button
                          type="button"
                          className="quantity-btn quantity-btn--minus"
                          disabled={loading}
                          onClick={() =>
                            decreaseQty(item.id, variationId, giftId)
                          }
                        >
                          {item.qty <= 1 ? "🗑" : "−"}
                        </button>
                      </div>
                    </div>

                    {/* TOTAL */}
                    <div className="cart-product-total">
                      <button
                        type="button"
                        className="save-for-later-btn"
                        onClick={() =>
                          moveToNextCart(
                            item.id,
                            item.selectedVariation?.variationId,
                            item.selectedGift?.id,
                          )
                        }
                      >
                        سبد خرید بعدی
                      </button>

                      {/* <span>
                      Total
                    </span> */}

                      <strong>
                        {(price * item.qty).toLocaleString("en-US")}

                        <small>تومان</small>
                      </strong>
                    </div>

                    {/* <div className="cart-item-actions">              

                 
                    <button
                      type="button"
                      className="cart-remove-btn"
                      onClick={() =>
                        removeFromCart(
                          item.id,
                          variationId,
                          giftId
                        )
                      }
                    >
                      حذف
                    </button>

                  </div> */}
                  </article>
                );
              })}
            </section>

            {/* SUMMARY */}
            <aside className="cart-summary">
              <h2>جزئیات قیمت</h2>

              <div className="summary-line">
                <span>قیمت کل سفارشات</span>

                <strong>{totalPrice.toLocaleString("en-US")} نومان</strong>
              </div>

              <div className="summary-line summary-discount">
                <span>تخفیف محصولات</span>

                <strong>{discountAmount.toLocaleString("en-US")} نومان</strong>
              </div>

              <div className="summary-divider" />

              <div className="summary-total">
                <span>مبلغ قابل پرداخت</span>

                <strong>{finalPrice.toLocaleString("en-US")} تومان</strong>
              </div>

              <button
                className="checkout-btn"
                onClick={handleCheckout}
                disabled={isCheckingCart || cart.length === 0}
              >
                {isCheckingCart ? (
                  <>
                    <span className="button-spinner" />
                    در حال بررسی موجودی...
                  </>
                ) : (
                  "تایید و ادامه"
                )}
              </button>

              <div className="secure-checkout">🔒 Secure checkout</div>
            </aside>
          </div>
        </div>


      </main>

      <LoginModal
        open={loginOpen}
        onClose={() => {
          setLoginOpen(false);
          setCheckoutAfterLogin(false);
        }}
        onLogin={() => {
          setLoginOpen(false);
        }}
      />
    </>
  );
}
